import { observer } from 'mobx-react-lite';
import { CurrencyConverterUI } from '../features/currency-converter/ui/currency-converter-ui';

export const CurrencyConverterObserver = observer(() => {
  return <CurrencyConverterUI />;
});
